import React, { FC } from 'react';
import { Image, Container } from 'react-bootstrap';
import PortfolioTable from '../portfolio/PortfolioTable';
import UserStatus from '../status-bar/UserStatus';
import Stats from '../../views/stats/Stats';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';
import { User } from '../../../../api/src/interfaces/shared';

interface Props {
  member: User;
  assets: AssetWithCalculatedStats[];
  hide: () => void;
}

const MemberPortfolio: FC<Props> = ({ member, hide, assets }) => (
  <>
    <div className="box">
      <div className="member-header">
        <div className="name">
          <Image
            src={`https://graph.facebook.com/v2.8/${member.facebookId}/picture?type=square`}
            roundedCircle
          />
          <span>{member.name}</span>
        </div>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={hide}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <UserStatus id={`${member.id}`} />
    </div>
    <div className="box">
      <div>
        <PortfolioTable assets={assets} deletable={false} />
      </div>
    </div>
    <Container>
      <Stats member={member} />
    </Container>
  </>
);

export default MemberPortfolio;
